export default __webpack_public_path__ + "static/media/logo.4515a0d4.png";